import React from 'react';

export const LOGO_URL = 'https://customer-assets-agu9un31.emergentagent.net/job_media-stage-25/artifacts/qiil6l84_brand%20stage%20logo.png';

export const BrandLogo = ({ className = 'h-9', testId = 'brand-logo' }) => (
  <img src={LOGO_URL} alt="BrandStage" className={`${className} w-auto object-contain`} data-testid={testId} />
);
